var map = {
	"./agent_back.svg": "63bc",
	"./copy.svg": "b420",
	"./dislike.svg": "c8bc",
	"./edit.svg": "2dd2",
	"./haoyou.svg": "e595",
	"./huaban.svg": "1398",
	"./like.svg": "8909",
	"./menu-left.svg": "696a",
	"./menu-right.svg": "c65d",
	"./plus.svg": "4eb1",
	"./refresh.svg": "d47a",
	"./share.svg": "940a",
	"./toggle-left.svg": "f022",
	"./toggle-right.svg": "69a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";